import { FixtureProvider } from '@/components/provider/fixture-contexts';
import { FantasyModule } from '@/modules/fantasy';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  tab: z.enum(['upcoming', 'live', 'completed', 'in-review']).optional(),
  sportType: z.string().optional(),
  searchScope: z.enum(['global', 'fixture', 'tournament']).optional(),
});

export const Route = createFileRoute('/dashboard/fantasy/')({
  validateSearch: searchSchema,
  component: FantasyPage,
});

function FantasyPage() {
  return (
    <FixtureProvider>
      <FantasyModule />
    </FixtureProvider>
  );
}
